import { useUserHasRole } from '../../hooks/useUserHasRole';
export const AdminHide: React.FC<{
	children: JSX.Element;
}> = ({ children }) => {
	const admin = useUserHasRole('admin');
	return <>{admin && children}</>;
};
